import standalones from '../contracts/standalones'

export const getTitle = (
  currentRoute: string,
  artistAccountId: string | null = null
) => {
  const currentTitleKey = titleKeys.find(
    titleKey => titleKey.route == currentRoute
  )

  const appName = artistAccountId
    ? standalones[artistAccountId].displayName
    : 'ユートニック'

  return currentTitleKey
    ? [currentTitleKey.title, appName].join(' | ')
    : appName
}

const titleKeys = [
  { route: '/', title: 'トップ', name: 'root' },
  { route: '/login', title: 'ログイン' },
  { route: '/resetPassword', title: 'パスワード再設定' },

  { route: '/signup', title: '新規登録' },
  { route: '/signup/email', title: 'メール新規登録' },
  { route: '/signup/profile', title: 'プロフィール設定' },
  { route: '/signup/verifyEmail', title: 'メール認証' },

  { route: '/logout', title: 'ログアウト' },

  { route: '/users/[id]', title: 'ユーザー情報' },

  { route: '/artists/[name]', title: 'アーティスト' },
  { route: '/artists/[name]/subscribe', title: 'メンバー登録' },

  { route: '/s/[word]', title: '検索' },
  { route: '/s', title: '検索' },

  { route: '/items/[id]', title: 'カード' },
  { route: '/items/[id]/serials/:serialId', title: '限定カード' },
  { route: '/items/[id]/complete', title: '購入完了' },

  { route: '/portfolios', title: 'ポートフォリオ' },
  { route: '/portfolios/[id]', title: 'ポートフォリオ' },
  { route: '/portfolios/[id]/resource', title: 'カードアイテム' },

  { route: '/collections/[id]', title: 'コレクション詳細' },

  { route: '/posts/[id]', title: 'ポスト' },

  /**
   * アカウント情報
   */
  { route: '/account', title: 'アカウント' },
  { route: '/account/payment', title: '決済情報' },
  { route: '/account/email', title: 'メールアドレス設定' },
  { route: '/account/password', title: 'パスワード設定' },
  { route: '/account/profile', title: 'プロフィール設定' },
  { route: '/account/subscription', title: '定期購読情報' },
  { route: '/account/purchaseHistory', title: '購入履歴' },

  /**
   * アーティスト画面
   */
  { route: '/artist/dashboard', title: 'ダッシュボード' },
  { route: '/artist/signup', title: 'アーティスト登録' },
  { route: '/artist/login', title: 'アーティストログイン' },

  { route: '/artist/account', title: 'アカウント' },
  { route: '/artist/account/email', title: 'メールアドレス設定' },
  { route: '/artist/account/password', title: 'パスワード設定' },
  { route: '/artist/account/profile', title: 'プロフィール設定' },
  { route: '/artist/account/bank/register', title: '口座情報設定' },
  { route: '/artist/account/business/register', title: 'ビジネス情報設定' },

  { route: '/artist/sales', title: '売上履歴' },
  { route: '/artist/sales/history', title: '販売履歴' },

  { route: '/artist/resources', title: 'リソース管理' },
  { route: '/artist/resources/:id', title: 'リソース詳細' },
  { route: '/artist/items', title: 'アイテム一覧' },
  { route: '/artist/orderHistory', title: '注文履歴' },
  { route: '/artist/items/new', title: 'アイテム新規作成' },
  { route: '/artist/items/[id]', title: 'アイテム詳細' },
  { route: '/artist/items/[id]/edit', title: 'アイテム編集' },
  { route: '/artist/items/[id]/owners', title: 'アイテム所持者一覧' },
  { route: '/artist/collections', title: 'コレクション一覧' },
  { route: '/artist/collections/[id]', title: 'コレクション詳細' },
  { route: '/artist/collections/[id]/edit', title: 'コレクション編集' },

  /**
   * 管理画面
   */
  { route: '/admin', title: '管理者画面' },
  { route: '/admin/artists', title: 'アーティスト管理' },
  { route: '/admin/artists/new', title: 'アーティスト新規作成' },
  { route: '/admin/artists/[id]', title: 'アーティスト詳細' },
  { route: '/admin/artists/[id]/edit', title: 'アーティスト編集' },
  { route: '/admin/items', title: 'アイテム管理' },
  { route: '/admin/items/[id]', title: 'アイテム詳細' },
  { route: '/admin/gachas', title: 'ガチャ管理' },
  { route: '/admin/gachas/new', title: 'ガチャ新規作成' },
  { route: '/admin/gachas/:id', title: 'ガチャ詳細' },
  { route: '/admin/gacha/:id/edit', title: 'ガチャ編集' },

  /**
   * スタンドアロンWeb
   */
  { route: '/standalone', title: 'トップ' },
  { route: '/standalone/login', title: 'ログイン' },
  { route: '/standalone/logout', title: 'ログアウト' },
  { route: '/standalone/resetPassword', title: 'パスワード再設定' },

  { route: '/standalone/home', title: 'ホーム' },

  { route: '/standalone/account', title: 'アカウント' },
  { route: '/standalone/account/payment', title: '決済情報' },
  { route: '/standalone/account/email', title: 'メールアドレス設定' },
  { route: '/standalone/account/password', title: 'パスワード設定' },
  { route: '/standalone/account/purchaseHistory', title: '購入履歴' },

  { route: '/standalone/collections', title: 'コレクション一覧' },
  { route: '/standalone/collections/[id]', title: 'コレクション' },

  { route: '/standalone/gachas', title: 'ガチャ' },
  { route: '/standalone/gachas/[id]/items/[itemId]', title: 'ガチャ結果' },

  { route: '/standalone/gachaTickets/[id]', title: 'ガチャチケット' },
  {
    route: '/standalone/gachaTickets/[id]/completed',
    title: 'ガチャチケット入手',
  },
  {
    route: '/standalone/gachaTickets/[id]/serials/[serialId]',
    title: '限定ガチャチケット',
  },

  { route: '/standalone/items/[id]', title: 'アイテム' },
  {
    route: '/standalone/items/[id]/completed',
    title: 'アイテム入手',
  },
  {
    route: '/standalone/items/[id]/serials/[serialId]',
    title: '限定アイテム',
  },

  { route: '/standalone/missions', title: 'ミッション一覧' },
  { route: '/standalone/missions/[id]', title: 'ミッション' },

  { route: '/standalone/portfolios', title: '所持アイテム一覧' },
  { route: '/standalone/portfolios/[id]', title: '所持アイテム' },
  { route: '/standalone/portfolios/[id]/resource', title: 'コンテンツ' },

  { route: '/standalone/profile', title: 'プロフィール' },
  { route: '/standalone/profile/setting', title: 'プロフィール設定' },
]
